import React, { useEffect, useState } from "react";
import {
  DeleteIdentification,
  Getagencypatientdetails,
  Patientrequestupdates,
  uploadImage,
} from "../../api/helper";
import { useForm } from "react-hook-form";
import { ShowToast } from "../../helpers/ToastService";
import DeleteModal from "../AgencyFlow/Components/DeleteModal";
import {
  Button,
  Card,
  CardContent,
  Input,
  Label,
} from "./ReuseableComponent/alert";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ReuseableComponent/Select";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const Identification = ({ data, onComplete }) => {
  const [info, setInfo] = useState({});
  const [uploadURL, setUploadURL] = useState("");
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  // Fetch patient identification details
  const getDetails = async () => {
    try {
      const response = await Getagencypatientdetails(
        data?.response?.patientRequestId
      );
      const resData = response?.data?.data;
      setInfo(resData);
    } catch (error) {
      console.error("Error fetching patient details:", error);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);

  const imagePicker = async (event) => {
    const file = event.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("images", file);

      try {
        const response = await uploadImage(formData);
        const uploadedFileUrl = response.data.data[0].URL;
        setUploadURL(uploadedFileUrl);
      } catch (error) {
        console.error("Upload failed:", error);
      }
    }
  };

  const onSubmit = async (formData) => {
    if (!uploadURL) {
      ShowToast("Please upload an ID image before submitting.");
      return;
    }

    const payload = {
      id: data?.response?.patientRequestId,
      Identification: [
        ...(info?.Identification || []),
        {
          IdentificationNumber: formData.IdentificationNumber,
          ExpirationDate: formData.ExpirationDate,
          TypeofID: formData.TypeofID,
          UploadCopy: uploadURL,
        },
      ],
    };

    try {
      const response = await Patientrequestupdates(payload);
      ShowToast(response?.data?.message || "Identification added");
      setUploadURL("");
      reset();
      getDetails();
      onComplete?.(true);
    } catch (error) {
      console.error("Error submitting identification:", error);
    }
  };
  const handleRemove = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);

    const data = {
      identificationId: deleteId,
      id: info?._id,
    };
    try {
      const respo = await DeleteIdentification(data);
      ShowToast(respo?.data?.message);
      getDetails();
    } catch (error) {
      console.log(error);
    }
  };


const toDataURL = (url) =>
  new Promise((resolve, reject) => {
    const proxyUrl = "https://cors-anywhere.herokuapp.com/";
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL("image/jpeg");
      resolve(dataURL);
    };
    img.onerror = () => {
      reject("Failed to load image (likely CORS issue)");
    };
    img.src = proxyUrl + url;
  });


const handleDownloadPDF = async () => {
  if (!info?.Identification || info.Identification.length === 0) {
    ShowToast("No identification data available.");
    return;
  }

  const doc = new jsPDF();
  doc.setFontSize(18);
  doc.text("Patient Identification Details", 14, 22);

  let currentY = 30;

  for (let i = 0; i < info.Identification.length; i++) {
    const item = info.Identification[i];

    doc.setFontSize(12);
    doc.text(`ID #${i + 1}`, 14, currentY);
    currentY += 6;
    doc.text(`Identification Number: ${item.IdentificationNumber || ""}`, 14, currentY);
    currentY += 6;
    doc.text(`Type of ID: ${item.TypeofID || ""}`, 14, currentY);
    currentY += 6;
    doc.text(`Expiration Date: ${item.ExpirationDate || ""}`, 14, currentY);
    currentY += 6;

    // Instead of embedding image (which breaks due to CORS), add clickable URL:
    doc.setTextColor("blue");
    doc.textWithLink("View ID Image", 14, currentY, { url: item.UploadCopy });
    doc.setTextColor("black");
    currentY += 10;

    if (currentY > 260 && i < info.Identification.length - 1) {
      doc.addPage();
      currentY = 20;
    }
  }

  doc.save(`Identification_${info?.firstName || "Patient"}.pdf`);
};


  return (
    <Card>
      <CardContent className="form-card-content">
        <form onSubmit={handleSubmit(onSubmit)} className="form-container">
          <div className="form-group_identification">
            <Label htmlFor="idType">ID Type *</Label>
            <Select
              onValueChange={(value) => setValue("TypeofID", value)}
              defaultValue=""
            >
              <SelectTrigger
                className="select-trigger"
                style={{ backgroundColor: "lightgrey", color: "black" }}
              >
                <SelectValue placeholder="Select ID Type" />
              </SelectTrigger>
              <SelectContent className="select-content">
                <SelectItem value="Driver's License">
                  Driver's License
                </SelectItem>
                <SelectItem value="Passport">Passport</SelectItem>
                <SelectItem value="State ID">State ID</SelectItem>
                <SelectItem value="Foreign National ID (for non-U.S. citizens)">
                  Foreign National ID (for non-U.S. citizens)
                </SelectItem>
                <SelectItem value="Temporary ID (Provisional ID or Certificate)">
                  Temporary ID (Provisional ID or Certificate)
                </SelectItem>
              </SelectContent>
            </Select>
            {errors.TypeofID && (
              <p className="error-message">ID Type is required</p>
            )}
            <input
              type="hidden"
              {...register("TypeofID", { required: true })}
            />
          </div>

          <div className="form-group_identification">
            <Label htmlFor="IdentificationNumber">ID Number *</Label>
            <input
              id="IdentificationNumber"
              type="text"
              className="verifyidentity-input"
              {...register("IdentificationNumber", { required: true })}
            />
            {errors.IdentificationNumber && (
              <p className="error-message">ID Number is required</p>
            )}
          </div>

          <div className="form-group_identification">
            <Label htmlFor="ExpirationDate">Expiration Date *</Label>
            <input
              id="ExpirationDate"
              type="date"
              className="verifyidentity-input"
              {...register("ExpirationDate", { required: true })}
            />
            {errors.ExpirationDate && (
              <p className="error-message">Expiration date is required</p>
            )}
          </div>

          <div className="form-group_identification">
            <Label htmlFor="photoID">Upload Photo ID *</Label>
            <input
              id="photoID"
              type="file"
              accept="image/*"
              onChange={imagePicker}
              className="input-file"
              required
            />
            <p className="hint-text">
              Please upload a clear photo of your identification document.
            </p>

            {uploadURL && (
              <div className="preview-container">
                <p className="preview-label">Uploaded Photo Preview:</p>
                <img
                  src={uploadURL}
                  alt="Uploaded ID"
                  className="preview-image"
                />
              </div>
            )}
          </div>

          <Button type="submit" className="submit-button">
            Save Identification
          </Button>
        </form>

        <table id="member-table">
          <thead>
            <tr>
              <th>Identification Number</th>
              <th>Type of ID</th>
              <th>Expiration Date</th>
              <th>Image</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {info?.Identification && info.Identification.length > 0 ? (
              info.Identification.map((item) => {
                const today = new Date();
                const expiration = new Date(item.ExpirationDate);
                const isExpired = expiration < today;

                return (
                  <tr key={item._id}>
                    <td>{item.IdentificationNumber}</td>
                    <td>{item.TypeofID}</td>
                    <td style={{ color: isExpired ? "red" : "inherit" }}>
                      {item.ExpirationDate}
                    </td>
                    <td>
                      <a
                        href={item.UploadCopy}
                        target="_blank"
                        rel="noreferrer"
                      >
                        View
                      </a>
                    </td>
                    <td className="custom-action-td">
                      <div className="custom-dropdown">
                        <button className="custom-action-button">
                          ⋮ Actions
                        </button>
                        <div className="custom-dropdown-menu">
                          <ul>
                            <li>
                              <button
                                className="custom-dropdown-item"
                                onClick={() => handleRemove(item._id)}
                              >
                                Delete
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5">No Identification Found</td>
              </tr>
            )}
          </tbody>
        </table>
        <Button
          style={{ marginTop: 10 }}
          className="w-full bg-[#BC9C22] hover:bg-[#9e7f1f]"
          onClick={handleDownloadPDF}
        >
          Download PDF
        </Button>
        {confirmdeletemodal && (
          <DeleteModal
            name="Identification"
            onClose={() => setconfirmdeletemodal(false)}
            onConfirm={confirmDelete}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default Identification;
